import React, { useEffect, useState } from 'react';
import { ui } from './ui';
import { DEFAULT_INSTRUCTIONS } from './paperUtils';
import { getMasterHeader, saveMasterHeader, errMsg } from './paperApi';

// Principal-only: school-wide default header applied automatically to every NEW paper.
export default function MasterHeaderPanel({ user, onSaved }) {
  const [h, setH] = useState({ schoolName: '', affiliation: '', logoUrl: '', session: '2026-27', customInstructions: [...DEFAULT_INSTRUCTIONS] });
  const [msg, setMsg] = useState({ type: '', text: '' });

  useEffect(() => {
    getMasterHeader(user).then((m) => { if (m) setH((p) => ({ ...p, ...m })); }).catch(() => {});
  }, [user]);

  const logo = (file) => {
    if (!file) return;
    if (file.size > 600 * 1024) return setMsg({ type: 'err', text: 'Logo must be under 600 KB.' });
    const r = new FileReader();
    r.onload = () => setH((p) => ({ ...p, logoUrl: String(r.result) }));
    r.readAsDataURL(file);
  };
  const save = async () => {
    try {
      const saved = await saveMasterHeader(user, h);
      setMsg({ type: 'ok', text: 'Master header saved. It will pre-fill all new papers.' });
      if (onSaved) onSaved(saved);
    } catch (e) { setMsg({ type: 'err', text: errMsg(e) }); }
  };

  return (
    <div style={ui.card}>
      <b>🏫 Central Master Header</b>
      <div style={{ fontSize: 12, color: '#64748b' }}>Applied automatically to every new paper created by you or any teacher (existing papers are not changed).</div>
      <span style={ui.label}>School name</span><input style={ui.input} value={h.schoolName} onChange={(e) => setH({ ...h, schoolName: e.target.value })} />
      <span style={ui.label}>Affiliation / code</span><input style={ui.input} value={h.affiliation} onChange={(e) => setH({ ...h, affiliation: e.target.value })} placeholder="CBSE Affiliation No. …" />
      <span style={ui.label}>Session</span><input style={ui.input} value={h.session} onChange={(e) => setH({ ...h, session: e.target.value })} />
      <span style={ui.label}>Logo</span>
      <div style={ui.row}>
        {h.logoUrl && <img src={h.logoUrl} alt="logo" style={{ width: 48, height: 48, objectFit: 'contain', border: '1px solid #e2e8f0' }} />}
        <input type="file" accept="image/png,image/jpeg,image/webp" onChange={(e) => logo(e.target.files[0])} style={{ fontSize: 12 }} />
      </div>
      <span style={ui.label}>Default instructions (one per line)</span>
      <textarea style={{ ...ui.input, minHeight: 100 }} value={h.customInstructions.join('\n')} onChange={(e) => setH({ ...h, customInstructions: e.target.value.split('\n') })} />
      <div style={{ marginTop: 10 }}><button type="button" style={ui.btnPrimary} onClick={save}>Save master header</button></div>
      {msg.text && <div style={msg.type === 'err' ? ui.err : ui.ok}>{msg.text}</div>}
    </div>
  );
}
